import { TYPES } from '../actions';

const initialState = {
  orders: [],
  totalCount: 0,
  loading: false,
  error: null,
  saleTeamStats: null,
  fulfillTeamStat: null
};

export const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ACTION_GET_ORDERS_SUCCESS:
      return {
        ...state,
        orders: action.payload.orders,
        totalCount: action.payload.totalCount,
        loading: false,
        error: null
      };
    case TYPES.ACTION_GET_ORDERS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case TYPES.ACTION_UPDATE_ORDERS_SUCCESS:
      var updatedOrderIds = action.payload.map(order => order._id);

      return {
        ...state,
        orders: state.orders.map(order => updatedOrderIds.includes(order._id) ? action.payload.find(o => o._id === order._id) : order),
        // loading: false,
        // error: null
      };
    case TYPES.ACTION_UPDATE_ORDERS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case TYPES.ACTION_GET_SALE_TEAM_STATUS_SUCCESS:
      return {
        ...state,
        saleTeamStats: action.payload,
        loading: false,
        error: null
      };
    case TYPES.ACTION_GET_SALE_TEAM_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case TYPES.ACTION_GET_FULFILL_TEAM_STAT_SUCCESS:
      return {
        ...state,
        fulfillTeamStat: action.payload,
        loading: false,
        error: null
      };
    case TYPES.ACTION_GET_FULFILL_TEAM_STAT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
}; 